export default "__VITE_ASSET__12bd7856__"